import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  emptyFeedback: {
    padding: theme.spacing(2, 0),
  },
}));
